import ApiClient from '../ApiClient';

import Buy from '../models/Engines/Buy';
import Email from '../models/Engines/Email';
import Ip from '../models/Engines/Ip';
import Key from '../models/Engines/Key';
import Link from '../models/Engines/Link';
import CollectionResponse from '../types/CollectionResponse';
import ErrorResponse from '../types/ErrorResponse';
import ItemResponse from '../types/ItemResponse';

class EnginesService extends ApiClient {
	async buysList(
		domain: string,
		onSuccess: (response: CollectionResponse<Buy>) => void,
		onError: (response: ErrorResponse) => void = () => {},
	) {
		await this.client
			.get('/engines/buys', { params: { domain: domain } })
			.then((response: any) => {
				onSuccess(response);
			})
			.catch(onError);
	}

	async ip(
		domain: string,
		onSuccess: (response: ItemResponse<Ip>) => void,
		onError: (response: ErrorResponse) => void = () => {},
	) {
		await this.client
			.get('/engines/ip', { params: { domain: domain } })
			.then((response: any) => {
				onSuccess(response);
			})
			.catch(onError);
	}

	async email(
		domain: string,
		onSuccess: (response: ItemResponse<Email>) => void,
		onError: (response: ErrorResponse) => void = () => {},
	) {
		await this.client
			.get('/engines/email', { params: { domain: domain } })
			.then((response: any) => {
				onSuccess(response);
			})
			.catch(onError);
	}

	async link(
		domain: string,
		onSuccess: (response: ItemResponse<Link>) => void,
		onError: (response: ErrorResponse) => void = () => {},
	) {
		await this.client
			.get('/engines/link', { params: { domain: domain } })
			.then((response: any) => {
				onSuccess(response);
			})
			.catch(onError);
	}

	async regenerate(
		domain: string,
		onSuccess: (response: ItemResponse<Link>) => void,
		onError: (response: ErrorResponse) => void = () => {},
	) {
		await this.client
			.get('/engines/regenerate', { params: { domain: domain } })
			.then((response: any) => {
				onSuccess(response);
			})
			.catch(onError);
	}

	async monitoringServiceKey(
		domain: string,
		onSuccess: (response: ItemResponse<Key>) => void,
		onError: (response: ErrorResponse) => void = () => {},
	) {
		await this.client
			.get('/engines/monitoring-service-key', { params: { domain: domain } })
			.then((response: any) => {
				onSuccess(response);
			})
			.catch(onError);
	}

	async md5Key(
		domain: string,
		onSuccess: (response: ItemResponse<Key>) => void,
		onError: (response: ErrorResponse) => void = () => {},
	) {
		await this.client
			.get('/engines/md5-key', { params: { domain: domain } })
			.then((response: any) => {
				onSuccess(response);
			})
			.catch(onError);
	}

	async copyrightKey(
		domain: string,
		onSuccess: (response: ItemResponse<Key>) => void,
		onError: (response: ErrorResponse) => void = () => {},
	) {
		await this.client
			.get('/engines/copyright-key', { params: { domain: domain } })
			.then((response: any) => {
				onSuccess(response);
			})
			.catch(onError);
	}
}

export default EnginesService;
